<template>
  <div>
    <sub-title
      :title="title"
      :content="content"
      :content2="content2"
      :content3="content3"
    >
    </sub-title>
    <section>
      <tab-menu :tabTitle="tabTitle"></tab-menu>
      <h2 class="hidden">
        다비치 고객가치경영연구원 인재 양성 사상, 사관 공채 지원 작성하기
      </h2>
      <div class="tab-items scroll-fade-in-f">
        <div class="tab-item recruit ly-cont-m display">
          <div class="recruit-board board-items">
            <p
              class="board-item board-recruiting"
              v-for="item in listToShow"
              :key="item.id"
            >
              <router-link
                :to="`/education/m_recruitDetail/${item.id}`"
                :class="{ isClose: isClosing(item.due_date) }"
                >{{ item.title }}
              </router-link>
              <span :class="{ isClose: isClosing(item.due_date) }"
                >~{{ item.due_date }}</span
              >
            </p>
          </div>

          <b-pagination
            id="pagination"
            v-model="currentPage"
            :per-page="perPage"
          ></b-pagination>

          <button class="el-btn-m" id="btnMoreData" @click="getMoreData">
            더보기
          </button>
        </div>

        <!-- @@@@@@@@@@@@@@@@@@@@@@사관공채지원 탭@@@@@@@@@@@@@@@@@@@@@@@@@@@@ -->
        <div class="tab-item apply">
          <!-- <div class="thought scroll-fade-in-f">
            <div class="img-wrap">
              <img src="https://img.davich.com/mobile/image/sub/education/education-apply.png" alt="오민사상" />
            </div>
            <div class="thought-item thought-item-1">
              <h4>민본(<span>民本</span>)</h4>
              <p>
                기본/원칙/법칙을 지키고 소통을 원활히 해서<br />
                지속적으로 성장하고 발전함
              </p>
            </div>
            <div class="thought-item thought-item-2">
              <h4>민성(<span>民性</span>)</h4>
              <p>
                정직과 양심으로 고객을 대하고<br />
                투명경영을 통하여 신뢰사회를 이룩함
              </p>
            </div>
            <div class="thought-item thought-item-3">
              <h4>민생(<span>民生</span>)</h4>
              <p>
                끊임 없는 교육을 통해 전문성을 확보하고,<br />
                변화·혁신을 주도하며 맡은 일에 책임을 다함
              </p>
            </div>
            <div class="thought-item thought-item-4">
              <h4>민격(<span>民格</span>)</h4>
              <p>
                최고의 제품과 서비스를 제공하여<br />
                소비자에게 맑고 밝은 세상을 만들어 줌
              </p>
            </div>
            <div class="thought-item thought-item-5">
              <h4>민복(<span>民福</span>)</h4>
              <p>
                배려와 봉사를 바탕으로<br />
                개인은 물론 주위 및 전체와 화합하고 상생함
              </p>
            </div>
            <div class="thoughttext">
              <h3>
                다비치 고객가치경영연구원은<br />
                오민사상을 기본으로 인재를 양성합니다.
              </h3>
              <p>
                기본을 지키며(민본) 정직하게 고객을 대하며(민성)<br />
                교육을 통한 꾸준한 전문성 함양과(민생) <br />
                최고의 제품과 서비스로(민격)<br />
                불우한 이웃에게도 봉사를 통해(민복)<br />
                맑고 밝은 세상을 만들겠다는 신념인 “오민사상”의<br />
                철학아래 교육에 임합니다. <br />
              </p>
            </div>
          </div> -->

          <div class="ly-form-m apply-form">
            <!-- <h2>사관∙공채 지원</h2> -->
            <div class="ly-form-cont">
              <h3>지원문의 내용</h3>
              <div class="form-cont ly-cont-m">
                <p class="apply-classify-form">
                  <em style="padding-top: 24px;">구분<span>&#42;</span></em>

                  <span class="radio-form-wrap">
<!--                    <span class="radio-form">-->
<!--                      <input-->
<!--                        id="apply-officer"-->
<!--                        type="radio"-->
<!--                        name="apply-classify"-->
<!--                        value="1"-->
<!--                        v-model="type"-->
<!--                        checked-->
<!--                      />-->
<!--                      <label for="apply-officer">사관</label>-->
<!--                    </span>-->
<!--                    <span class="radio-form">-->
<!--                      <input-->
<!--                        id="apply-officer-2"-->
<!--                        type="radio"-->
<!--                        value="2"-->
<!--                        v-model="type"-->
<!--                        name="apply-classify"-->
<!--                      />-->
<!--                      <label for="apply-officer-2">공채</label>-->
<!--                    </span>-->

                    <span class="radio-form">
                      <input
                          id="apply-officer"
                          type="radio"
                          name="apply-classify"
                          value="4"
                          v-model="type"
                          checked
                          :disabled="officer_disabled"
                      />
                      <label for="apply-officer">사관학교</label>
                    </span>
                    <span class="radio-form">
                      <input
                        id="apply-officer-3"
                        type="radio"
                        value="3"
                        v-model="type"
                        name="apply-classify"
                        :disabled="coordinator_disabled"
                      />
                      <label for="apply-officer-3">코디네이터</label>
                    </span>
                  </span>
                </p>

                <p class="name-form">
                  <label for="name">성함<span>&#42;</span></label>
                  <input
                    id="name"
                    type="text"
                    placeholder="성함을 입력해주세요."
                    v-model="name"
                    maxlength="20"
                  />
                </p>
                <p class="email-form">
                  <label for="email">이메일<span>&#42;</span></label>
                  <input
                    id="email"
                    type="email"
                    placeholder=""
                    v-model="tempEmail"
                    @blur="sumDomain"
                    required
                  />
                  <span class="">&#64;</span>
                  <label for="input-domain" class="hidden"
                    >이메일 도메인 주소창</label
                  >
                  <input
                    id="input-domain"
                    type="text"
                    v-model="inputDomain"
                    @blur="sumDomain"
                  />
                  <label for="select-domain" class="hidden"
                    >이메일 도메인 주소 선택</label
                  >
                  <select
                    id="select-domain"
                    v-model="domain"
                    @change="sumDomain"
                  >
                    <option :value="''" selected disabled>선택</option>
                    <option :value="'naver.com'">naver.com</option>
                    <option :value="'hanmail.net'">hanmail.net</option>
                    <option :value="'gmail.com'">gmail.com</option>
                    <option :value="'daum.net'">daum.net</option>
                    <option :value="'nate.com'">nate.com</option>
                    <option :value="0">직접입력</option>
                  </select>
                </p>
                <p class="number-form">
                  <label for="phonenumber">휴대폰<span>&#42;</span></label>
                  <span>
                    <!--01 연락처 입력부분-->
                    <span class="certifi-num-wrap">
                      <input
                        id="phonenumber"
                        type="tel"
                        placeholder="'-'제외하고 숫자만입력"
                        v-model="mobile_no"
                        maxlength="11"
                      />
                      <!--참고_인증번호 받기 버튼 활성화 시 클래스 active 추가-->
                      <!--버튼(인증번호 받기 전)-->
                      <button
                        id="get-authnum-btn"
                        class="certifi-num-btn"
                        @click="certifyMobile"
                      >
                        인증번호 받기
                      </button>
                      <!--버튼(인증번호 받은 후)-->
                      <!-- <button class="certifi-num-btn reissuance">재발급</button> -->
                      <!--연락처 올바르지 않을 시 나타나는 문구-->
                      <span class="caution hidden"
                        >올바른 휴대폰 번호를 입력해주세요.</span
                      >
                    </span>
                    <!--02 인증번호 입력부분-->
                    <span class="certifi-num-wrap">
                      <!-- <label for="certification" class="">인증번호 입력</label> -->
                      <input
                        class="hidden"
                        id="certifi-input"
                        type="text"
                        placeholder="인증번호를 입력해주세요."
                        v-model="authNumber"
                        maxlength="6"
                      />
                      <!--문구(인증번호 받은 후)-->
                      <span class="caution hidden" id="timer"
                        >인증번호가 발송되었습니다.
                        <em> 유효시간 {{ timeStr }}초</em></span
                      >
                      <!--문구(인증번호 틀린 후)-->
                      <span class="caution hidden"
                        >인증번호가 일치하지 않습니다.
                        <em> 유효시간 : 3:00초</em></span
                      >
                      <!--문구(인증번호 유효시간 초과 시)-->
                      <span class="caution hidden"
                        >인증번호를 재발급 해주세요. 유효시간 초과</span
                      >
                      <!--문구(인증번호 인증 완료 후)-->
                      <span class="caution confirm hidden"
                        >인증이 완료되었습니다.</span
                      >

                      <!--참고_인증하기 버튼 활성화 시 클래스 active 추가-->
                      <button
                        class="certifi-num-btn hidden"
                        id="certifi-btn"
                        @click="confirmMobile"
                      >
                        인증번호 확인
                      </button>
                    </span>
                  </span>
                </p>

                <p class="file-form">
                  <label for="upload-name">파일첨부</label>
                  <span>
                    <input
                      id="upload-name"
                      class="upload-name"
                      :value="file.name"
                      placeholder="첨부파일"
                    />

                    <div class="file-btn-wrap">
                      <label for="avatar">찾아보기</label>
                      <span id="delete-file">
                        <button>
                          <img
                            src="https://img.davich.com/image/sub/partnership/icon-x-square.png"
                            alt="x icon"
                          />
                          파일삭제
                        </button></span
                      >
                    </div>
                    <input
                      type="file"
                      id="avatar"
                      name="avatar"
                      accept="PDF, DOC, DOCX, PPT, PPTX, HWP, GUL,
                  GIF, JPG, PNG, ZIP, TXT"
                    />

                    <em
                      >50MB를 초과 할 수 없으며 PDF, DOC, DOCX, PPT, PPTX, HWP,
                      GUL, GIF, JPG, PNG, ZIP, TXT 파일만 가능합니다.</em
                    >
                  </span>
                </p>
                <!-- 지원서 첨부 부분 -->
              </div>
            </div>
            <div class="ly-form-agree">
              <h3>개인정보 수집동의</h3>
              <div class="agree-cont ly-cont-m">
                <!-- <div class="agree-txt" v-html="contents"></div> -->
                <div class="agree-txt">
                  <div style="font-size:20px; font-weight: bold; ">㈜다비치안경체인 개인정보 처리방침</div>
    <p>
        <br/>
        <br/>
        주식회사 다비치안경체인(이하 “회사”라 함)은 이용자(회사가 제공하는 서비스를 이용하는 회원 및 비회원)의 개인정보를 안전하게 보호하기 위하여 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」, 「개인정보보호법」 등의 관련 최신 법령을 준수하고 있으며, 이에 따라 개인정보 처리방침을 정하여 이용자의 권익 보호에 최선을 다하고 있습니다.
        <br/>
        본 개인정보 처리방침은 다비치안경 가맹점 및 회사가 제공하는 다양한 온라인/오프라인 서비스 이용에 적용되며, 회사는 본 개인정보 처리방침을 홈페이지 첫 화면에 공개하여 이용자가 언제든지 확인할 수 있도록 조치하고 있습니다. 본 개인정보 처리방침은 관련 법령 및 회사의 정책 등에 따라 변경될 수 있으므로 이용자는 수시로 확인하여 주시기 바랍니다.
        <br/>
        <br/>
        <b style="font-size:20px">개인정보의 처리목적</b>
        <br/>
        회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
        <br/>
        <br/>
        <b style="font-size:16px"> 1. 회원가입 및 관리</b>
        <br/>
        회원제 서비스 제공에 따른 본인 식별·인증 및 회원자격 유지·관리
        <br/>
        약관 위반 고객에 대한 이용 제한 및 서비스 부정이용 방지
        <br/>
        만 14세 미만 아동의 개인정보 처리 시 법정대리인의 동의 여부 확인
        <br/>
        각종 고지·통지 및 고충처리·온라인문의처리
        <br/>
        회원가입 및 탈퇴 의사 확인
        <br/>
        <br/>
        <b style="font-size:16px">2. 재화 또는 서비스 제공</b>
        <br/>
        서비스 제공에 관한 계약 이행
        <br/>
        콘텐츠 제공, 상품·상품권 주문 및 요금 결제, 물품 배송
        <br/>
        금융거래 본인 인증 및 금융서비스
        <br/>
        회원 맞춤서비스 제공
        <br/>
        <br/>
        <b style="font-size:16px"> 3. 마케팅 활용 및 통계</b>
        <br/>
        이벤트 등 광고성 정보 전달
        <br/>
        접속 빈도 파악 등 서비스 이용에 대한 통계
        <br/>
        <br/>
        <b style="font-size:16px">4. 가맹점 개설 및 제휴 상담</b>
        <br/>
        가맹점 개설 문의 및 상담
        <br/>
        마케팅, 입점, 제품 관련 등 제휴 문의 및 상담
        <br/>
        <br/>
        <b style="font-size:16px">5. 다비치 사관·공채·코디네이터 모집</b>
        <br/>
        교육가치경영연구원 교육 연수생 모집
        <br/>
        <br/>
        <b style="font-size:20px">처리하는 개인정보 항목 및 보유기간</b>
        <br/>
        회사는 서비스 제공을 위해 필요 최소한의 범위에서 개인정보를 수집하고, 법령에 따른 개인정보 보유·처리기간 또는 이용자로부터 수집 시에 동의 받은 개인정보 보유·처리기간 내에서 개인정보를 보유 및 처리합니다.
        <br/>
        <br/>
        <b style="font-size:16px">1. 이용자의 동의를 받지 않고 처리하는 개인정보 항목</b>
        <br/>
        회사는 다음의 개인정보 항목을 「개인정보 보호법」 제15조 제1항 제4호 및 제22조의2 제2항에 의해 이용자의 동의없이 처리하고 있습니다.
    <table class="table_1">
        <tr>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                법적 근거
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                구분
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                수집 목적
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                수집 항목
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                보유 및 처리기간
            </th>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                개인정보 보호법
                <br/>
                제15조 제1항
                <br/>
                제4호(계약의 이행)
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                회원 가입 및  관리
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                일반 회원가입에 따른 본인 식별·인증
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                (필수)아이디, 비밀번호, 성명, 휴대전화번호, 생년월일, 성별, 내/외국인 구분, 통신사, CI, DI
                <br/>
                (선택)이메일, 닉네임
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                회원탈퇴 시까지
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                개인정보 보호법
                <br/>
                제15조 제1항
                <br/>
                제4호(계약의 이행)
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                회원 가입 및  관리
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                간편 회원가입(카카오, 네이버, 애플)
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                (필수)이용자 식별자(이메일 또는 휴대전화번호), 비밀번호
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                회원탈퇴 시까지
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                개인정보 보호법
                <br/>
                제15조 제1항
                <br/>
                제4호(계약의 이행)
                <br/>
                제22조의2(아동의 개인정보 보호) 제2항
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                회원 가입 및  관리
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                회원 가입 시 만 14세 미만 아동의 법정대리인(보호자) 동의
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                만 14세 미만 아동
                <br/>
                (필수)아이디, 비밀번호, 성명, (휴대)전화번호
                <br/>
                (선택)이메일, 닉네임
                <br/>
                2. 법정대리인(보호자)
                <br/>
                (필수)성명, 휴대전화번호
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                회원탈퇴 시까지
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                개인정보 보호법
                <br/>
                제15조 제1항
                <br/>
                제4호(계약의 이행)
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                회원 가입 및  관리
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                간편 로그인
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                (필수)이용자 식별자(이메일 또는 휴대전화번호), 비밀번호
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                로그아웃 시까지
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                개인정보 보호법
                <br/>
                제15조 제1항
                <br/>
                제4호(계약의 이행)
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                회원 가입 및  관리
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                서비스 부정이용 방지
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                (필수)아이디, 비밀번호, 성명, 휴대전화번호, CI, DI
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                회원탈퇴 후 3개월
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                개인정보 보호법
                <br/>
                제15조 제1항
                <br/>
                제4호(계약의 이행)
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                서비스 제공
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                고객 상담 및 민원 처리
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                (필수)성명, (휴대)전화번호, 이메일, 문의내용, 처리내용
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                3년
                <br/>
                (전자상거래법
                <br/>
                제6조)
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                개인정보 보호법
                <br/>
                제15조 제1항
                <br/>
                제4호(계약의 이행)
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                서비스 제공
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                주문 및 결제
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                (필수)성명, (휴대)전화번호, 이메일, 결제수단정보(신용카드, 간편결제, 가상계좌)
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                5년
                <br/>
                (전자상거래법
                <br/>
                제6조)
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                개인정보 보호법
                <br/>
                제15조 제1항
                <br/>
                제4호(계약의 이행)
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                서비스 제공
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                물품 배송 및 배송지 관리
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                (필수)성명, (휴대)전화번호, 주소
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                5년
                <br/>
                (전자상거래법
                <br/>
                제6조)
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                개인정보 보호법
                <br/>
                제15조 제1항
                <br/>
                제4호(계약의 이행)
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                서비스 제공
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                환불계좌 관리
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                (필수)예금주, 은행명, 계좌번호
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                5년
                <br/>
                (전자상거래법
                <br/>
                제6조)
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                개인정보 보호법
                <br/>
                제15조 제1항
                <br/>
                제4호(계약의 이행)
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                서비스 제공
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                계약사항 및 주문내역 안내
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                (필수)성명, (휴대)전화번호
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                5년
                <br/>
                (전자상거래법
                <br/>
                제6조)
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                개인정보 보호법
                <br/>
                제15조 제1항
                <br/>
                제4호(계약의 이행)
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                서비스 제공
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                방문 예약
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                (필수)성명, (휴대)전화번호
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                방문 예약 후 1년
            </td>
        </tr>
    </table>
    ※ 부정이용자: 신규 회원가입 할인쿠폰(적립금)을 발급받기 위해 회원탈퇴 및 회원가입을 반복적으로 행하는 등 회사가 정한 기준에 따라 부정하게 이용하는 이용자
    <br/>
    <br/>
    <b style="font-size:16px">2. 이용자의 동의를 받아 처리하는 개인정보 항목</b>
    <br/>
    회사는 다음의 개인정보 항목을 「개인정보 보호법」 제15조 제1항 제1호, 제22조 제1항 제7호 및 제23조 제1항 제1호에 따라 이용자의 동의(각각 구분 동의)를 받아 처리하고 있습니다.

    <table class="table_1">
        <tr>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                법적 근거
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                구분
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                수집 목적
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                수집 항목
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                보유 및 이용기간
            </th>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                개인정보 보호법
                <br/>
                제22조 제1항
                <br/>
                제7호(재화/서비스 홍보 및 판매 권유)
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                마케팅 활용
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                제품 홍보 및 판매 권유를 위한 광고성 정보 전송수단 선택
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                (선택)광고성 정보 전송 수단 (이메일, 문자메시지, 앱푸시, 카카오톡)
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                회원탈퇴 또는 마케팅 수신 동의 철회 시까지
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                개인정보 보호법
                <br/>
                제23조 제1항
                <br/>
                제1호(민감정보 처리 시 별도 동의)
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                민감정보 수집·이용
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                가맹점 방문고객 시력정보, 청력정보 측정
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                (필수)시력검사정보, 안경/렌즈 도수, 얼굴사이즈정보(얼굴 가로/세로/옆면 길이)
                <br/>
                (선택)청력검사정보
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                회원탈퇴 시까지
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                개인정보 보호법
                <br/>
                제15조 제1항
                <br/>
                제1호(정보주체의 동의)
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                가맹점 개설 심사
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                가맹점 개설 문의 및 상담
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                (필수)성명, (휴대)전화번호, 이메일
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                상담 후 1년
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                개인정보 보호법
                <br/>
                제15조 제1항
                <br/>
                제1호(정보주체의 동의)
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                제휴 심사
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                마케팅, 입점, 시스템, 제품 관련 등 제휴 문의 및 상담
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                (필수)성명, (휴대)전화번호, 이메일
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                상담 후 1년
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                개인정보 보호법
                <br/>
                제15조 제1항
                <br/>
                제1호(정보주체의 동의)
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                교육연수생 모집
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                사관·공채 교육연수생 선별
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                (필수)사진, 성별, 성명(한글), 생년월일, 휴대전화번호, 주소, 이메일
                <br/>
                (선택)성명(영문), 출신학교, MBTI, 비상연락망
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                (합격자)교육 시작 후 6개월
                <br/>
                (불합격자)선별 후 5일 이내
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                개인정보 보호법
                <br/>
                제15조 제1항
                <br/>
                제1호(정보주체의 동의)
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                교육연수생 모집
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                코디네이터 교육연수생 선별
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                (필수)사진, 성별, 성명, 생년월일, 휴대전화번호, 주소, 이메일
                <br/>
                (선택)고등학교명, 학년, 학과, 병역여부, MBTI, 비상연락망
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                (합격자)교육 시작 후 6개월
                <br/>
                (불합격자)선별 후 5일 이내
            </td>
        </tr>
    </table>
    <br/>
    <b style="font-size:16px">3. 자동으로 수집되는 개인정보 항목</b>
    <br/>
    서비스 이용 과정 중 다음의 개인정보 항목이 자동 생성되어 수집되고 있습니다.
    <table class="table_1">
        <tr>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                법적 근거
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                구분
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                수집 목적
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                수집 항목
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                보유 및 이용기간
            </th>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                개인정보 보호법
                <br/>
                제30조 제1항
                <br/>
                제7호(자동수집장치에 관한 사항)
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                PC 로그인
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                서비스 개선, 오류 확인, 신규 서비스 개발, 부정 이용 방지, 맞춤 광고 제공, 서비스 이용 통계 분석
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                (필수)서비스 이용 및 중지 기록, 쿠키, 로그인 정보(IP주소, OS정보, 기기 식별 값)
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                회원탈퇴 시까지
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                개인정보 보호법
                <br/>
                제30조 제1항
                <br/>
                제7호(자동수집장치에 관한 사항)
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                모바일웹 사용
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                서비스 개선, 오류 확인, 신규 서비스 개발, 부정 이용 방지, 맞춤 광고 제공, 서비스 이용 통계 분석
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                (필수)모바일기기고유번호(UUID), 단말기OS정보, 광고식별자, 이동통신회사, PUSH 수신여부
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                회원탈퇴 시까지
            </td>
        </tr>
    </table>
    <br/>
    <br/>
    <b style="font-size:20px">14세 미만 아동의 개인정보 처리에 관한 사항</b>
    <br/>
    ① 회사는 14세 미만 아동의 개인정보를 처리하기 위하여 동의가 필요한 경우에는 해당 아동의 법정대리인으로부터 동의를 받습니다.
    <br/>
    <br/>
    ② 회사는 14세 미만 아동의 개인정보 처리에 관하여 그 법정대리인의 동의를 받을 때에는 아동에게 법정대리인의 성명, 연락처와 같이 최소한의 정보를 요구할 수 있으며, 동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고, 그 동의 표시를 확인하였음을 법정대리인의 휴대전화 문자메시지로 알리는 방법으로 그 사실을 확인합니다.
    <br/>
    <br/>
    <b style="font-size:20px">개인정보의 파기 절차 및 방법에 관한 사항</b>
    <br/>
    ① 회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.
    <br/>
    <br/>
    ② 이용자로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.
    <br/>
    ※ 다른 법령에 따라 보존하는 개인정보의 항목과 보존 근거는 다음과 같습니다.
    <br/>
    「전자상거래 등에서의 소비자보호에 관한 법률 시행령」 제6조
    <br/>
    1. 표시ㆍ광고에 관한 기록: 6개월
    <br/>
    2. 계약 또는 청약철회 등에 관한 기록: 5년
    <br/>
    3. 대금결제 및 재화등의 공급에 관한 기록: 5년
    <br/>
    4. 소비자의 불만 또는 분쟁처리에 관한 기록: 3년
    <br/>
    <br/>
    ③ 개인정보 파기의 절차 및 방법은 다음과 같습니다.
    <br/>
    1. 파기절차
    <br/>
    회사는 파기 사유가 발생한 개인정보를 선정하고, 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.
    <br/>
    2. 파기방법
    <br/>
    회사는 전자적 파일 형태로 기록.저장된 개인정보는 기록을 재생할 수 없도록 파기하며, 종이 문서에 기록.저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.
    <br/>
    <br/>
    <b style="font-size:20px">개인정보의 제3자 제공에 관한 사항</b>
    <br/>
    회사는 이용자의 개인정보를 개인정보의 처리 목적에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공하고 그 이외에는 정보주체의 개인정보를 제3자에게 제공하지 않습니다.
    <br/>
    <br/>
    <b style="font-size:20px">개인정보 처리업무의 위탁에 관한 사항</b>
    <br/>
    회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.

    <p>
        <a href="/" id="download-link" target="_blank">다비치안경체인 가맹점 리스트</a>
    </p>

    <table class="table_1">
        <tr>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                위탁받는 자
                <br/>
                (수탁자)
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                위탁업무
            </th>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                ㈜인터비젼
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                대표 홈페이지 유지 관리(가맹점 개설, 사관·공채모집 등
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                ㈜쓰리웨이
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                다비치히어링 홈페이지 유지 관리
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                ㈜메디오피아테크
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                고객가치경영연구원 홈페이지 유지 관리(수강신청, 내강의실 등)
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                서울신용평가정보㈜
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                본인인증 서비스
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                가비아㈜
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                이메일 발송 서비스
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                씨제이올리브네트웍스㈜
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                메시지 발송 서비스(문자/카카오톡/앱 PUSH 등)
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                ㈜케이지이니시스
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                결제 서비스
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                ㈜로젠택배
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                배송 서비스
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                다비치안경체인 가맹점
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                방문고객 회원 가입, 제품 판매 및 홍보
            </td>
        </tr>
    </table>
    <br/>
    ② 회사는 위탁계약 체결 시 「개인정보 보호법」 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적.관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리.감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
    <br/>
    ③ 「개인정보 보호법」 제26조 제6항에 따라 수탁자가 당사의 개인정보 처리업무를 재위탁하는 경우 회사의 동의를 받고 있습니다.
    <br/>
    ④ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.
    <br/>
    <br/>
    <br/>
    개인정보의 안전성 확보조치에 관한 사항
    <br/>
    <br/>
    회사는 이용자의 개인정보를 보호하기 위해 다음과 같은 조치를 마련하여 적용하고 있습니다.
    <br/>
    <br/>
    ① 관리적 보호조치
    <br/>
    개인정보의 안전한 관리를 위해 내부관리계획을 수립, 시행하고 있습니다.
    <br/>
    개인정보를 취급하는 담당직원을 최소한으로 제한하고, 관련 직원을 대상으로 보안교육을 실시하고 있습니다.
    <br/>
    개인정보 안전성 확보를 위해 정기적으로 자체 점검/감사를 실시하고 있습니다.
    <br/>
    <br/>
    ② 기술적 보호조치
    <br/>
    이용자의 비밀번호를 암호화하여 저장, 관리하고 있습니다.
    <br/>
    파일 및 전송 데이터를 암호화하여 보호하고 있습니다.
    <br/>
    개인정보를 처리하는 데이터베이스시스템에 대한 접근권한을 제한하고 있습니다.
    <br/>
    침입차단시스템을 이용해 외부로부터의 불법접근을 차단하고 있습니다.
    <br/>
    개인정보처리시스템에 접속한 기록을 보관, 관리하고 있으며 접속기록이 위조, 변조, 도난, 분실되지 않도록 안전하게 보관하고 있습니다.
    <br/>
    해킹이나 악성코드, 악의적인 내부자 등에 의한 개인정보 유출 및 훼손을 막기 위해 보안프로그램을 설치하고 주기적으로 점검, 갱신하고 있습니다.
    <br/>
    <br/>
    ③ 물리적 보호조치
    <br/>
    개인정보가 포함된 서류, 보조저장매체 등을 잠금 장치가 있는 안전한 장소에 보관하고 있으며, 출입통제 절차를 수립, 운영하고 있습니다.
    <br/>
    <br/>
    <br/>
    <b style="font-size:20px">개인정보 자동수집 장치의 설치·운영 및 거부에 관한 사항</b>
    <br/>
    <br/>
    ① 회사는 개인화된 서비스를 제공하기 위해 쿠키(cookie), IP주소, 접속기기 정보를 수집하여 사용합니다.
    <br/>
    쿠키는 웹서버에서 사용자의 브라우저에 보내는 아주 작은 텍스트 파일로서 이용자의 컴퓨터 하드드라이브에 저장됩니다. 이후 다시 웹사이트 방문 시 서버는 이용자의 PC에 저장된 쿠키의 내용을 읽어 이용자가 설정한 서비스 이용 환경을 유지합니다.
    <br/>
    IP주소는 인터넷 망 사업자가 인터넷에 접속하는 PC 등 기기에 부여하는 온라인주소 정보입니다.
    <br/>
    접속기기 정보는 기기의 구동을 위해 사용되는 S/W를 통해 확인 가능한 정보입니다.
    <br/>
    <br/>
    ② 회사는 다음과 같은 목적으로 쿠키를 사용합니다.
    <br/>
    사이트 방문 및 이용 형태, 구매 품목, 관심 상품 등을 분석하여 이용자의 취향과 관심에 특화된 맞춤 서비스(광고 포함) 제공을 위해 사용됩니다.
    <br/>
    회사가 진행하는 각종 이벤트에서 이용자의 참여 정도 및 방문 수를 파악하여 차별적인 응모 기회를 부여하고, 개인의 관심 분야에 따라 차별화된 정보를 제공하기 위한 자료로 이용됩니다.
    <br/>
    <br/>
    ③ 이용자는 쿠키에 대한 선택권을 가지고 있습니다. 웹 브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다. 단, 쿠키의 저장을 거부할 경우에는 로그인이 필요한 일부 서비스 이용에 어려움이 있을 수 있습니다.
    <br/>
    <br/>
    가. 웹 브라우저에서 쿠키 수집을 차단하는 방법
    <table class="table_1">
        <tr>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                웹 브라우저
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                쿠키 수집 차단 방법
            </th>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                Chrome
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                설정 &gt; 개인정보 보호 및 보안 &gt; 인터넷 사용 기록 삭제
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                Edge
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                설정 &gt; 쿠키 및 사이트 권한 &gt; 쿠키 및 사이트 데이터 관리 및 삭제
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                Safari
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                설정 &gt; 개인 정보 보호 &gt; 쿠키 및 웹 사이트 데이터
            </td>
        </tr>
    </table>

    나. 모바일 브라우저에서 쿠키 수집을 차단하는 방법

    <table class="table_1">
        <tr>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                웹 브라우저
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                쿠키 수집 차단 방법
            </th>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                Chrome
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                설정 &gt; 개인정보 보호 및 보안 &gt; 인터넷 사용 기록 삭제
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                Edge
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                설정 &gt; 고급 &gt; 모든 쿠키 차단
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                Safari
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                설정 &gt; 인터넷 사용 기록 &gt; 인터넷 사용 기록 삭제
            </td>
        </tr>
    </table>
    <br/>
    <b style="font-size:20px">행태정보의 수집.이용.제공 및 거부 등에 관한 사항</b>
    <table class="table_1">
        <tr>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                법적 근거
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                수집 항목
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                수집 방법
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                수집 목적
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                보유 및 이용기간
            </th>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                개인정보 보호법
                <br/>
                제15조 제1항 제1호
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                이용자의 서비스 방문·이용 기록, 활동 로그 및 검색 이력, 광고식별자
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                이용자가 서비스 이용 시 자동 수집·전송
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                서비스 이용 실적 통계·분석, 서비스 개선 및 관련 신규 서비스 개발, 맞춤형 상품 추천 서비스 제공, 맞춤형 광고, 맞춤형 혜택 및 상품·서비스 정보 제공, 광고 성과 측정
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                회원탈퇴 시까지
            </td>
        </tr>
    </table>
    <br/>
    ① 회사는 서비스 이용과정에서 사용자에게 최적화된 맞춤형 서비스 및 혜택, 온라인 맞춤형 광고 등을 제공하기 위하여 쿠키를 활용하여 개인을 식별 가능한 형태로 행태정보를 수집·이용하고 있습니다.
    <br/>
    ※ 행태정보란?
    <br/>
    웹 사이트 방문 이력, 앱 사용 이력, 구매 및 검색 이력 등 이용자의 관심, 흥미, 기호 및 성향 등을 파악하고 분석할 수 있는 온라인상의 이용자 활동정보를 말합니다.
    <br/>
    ② 회사는 자사가 운영하는 웹사이트에서 다음과 같이 행태정보를 수집하고 있습니다.
    <br/>
    ③ 회사는 최적화된 맞춤형 서비스 및 혜택, 온라인 맞춤형 광고 등에 필요한 최소한의 행태정보만을 수집하며, 사상, 신념, 학력·병력 등 개인의 권리·이익이나 사생활을 침해할 우려가 있는 민감한 행태정보를 수집하지 않습니다.
    <br/>
    ④ 회사는 14세 미만임을 알고 있는 아동에게 맞춤형 광고를 제공하려는 경우 사전에 법정대리인의 동의를 받고 있으며, 이외에는 맞춤형 광고를 목적으로 아동의 행태정보를 수집하지 않고, 아동에게 맞춤형 광고를 제공하지 않습니다.
    <br/>
    ⑤ 이용자는 다음의 방법을 통해 언제든지 맞춤형 광고 등 목적의 행태정보 수집을 차단할 수 있습니다. 단, 행태정보 수집을 차단하는 경우에도 이용자와 관련성이 낮은 광고가 노출될 수 있습니다.
    <br/>
    가. 웹 브라우저에서 행태정보 수집을 차단하는 방법

    <table class="table_1">
        <tr>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                웹 브라우저
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                행태정보 수집 차단 방법
            </th>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                Chrome
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                설정 &gt; 개인정보 보호 및 보안 &gt; 인터넷 사용 기록 삭제
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                Edge
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                설정 &gt; 쿠키 및 사이트 권한 &gt; 쿠키 및 사이트 데이터 관리 및 삭제
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                Safari
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                설정 &gt; 개인 정보 보호 &gt; 쿠키 및 웹 사이트 데이터
            </td>
        </tr>
    </table>
    <br/>
    <br/>
    나. 앱에서 행태정보 수집을 차단하는 방법

    <table class="table_1">
        <tr>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                모바일 OS
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                모바일 단말기의 광고식별자 차단 방법
            </th>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                Android
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                설정 &gt; 보안 및 개인정보보호 &gt; 기타 개인정보 설정 &gt; 광고 &gt; 광고 ID 재설정 / 광고 ID 삭제
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                iOS
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                설정 &gt; 개인정보 보호 및 보안 &gt; 추적 &gt; 앱이 추적을 요청하도록 허용 (OFF)
            </td>
        </tr>
    </table>
    <br/>
    ⑥ 이용자는 아래의 연락처로 행태정보와 관련하여 궁금한 사항과 거부권 행사, 피해 신고 접수 등을 문의할 수 있습니다.

    <table class="table_1">
        <tr>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                부서명
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                담당자
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                연락처
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                이메일
            </th>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                정보보안팀
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                한재환
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                070-7433-0825
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                ddor3@davich.com
            </td>
        </tr>
    </table>
    <br/>
    <b style="font-size:20px">정보주체와 법정대리인의 권리·의무 및 행사방법에 관한 사항</b>
    <br/>
    <br/>
    ① 이용자는 회사에 대해 언제든지 개인정보 열람·정정·삭제·처리정지 및 철회 요구, 자동화된 결정에 대한 거부 또는 설명 요구 등의 권리를 행사(이하 “권리 행사”라 함)할 수 있습니다.
    <br/>
    ※ 14세 미만 아동에 관한 개인정보의 열람등 요구는 법정대리인이 직접 해야 하며, 14세 이상의 미성년자인 정보주체는 정보주체의 개인정보에 관하여 미성년자 본인이 권리를 행사하거나 법정대리인을 통하여 권리를 행사할 수도 있습니다.
    <br/>
    <br/>
    ② 권리 행사는 회사에 대해 「개인정보 보호법」 시행령 제41조 제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며, 회사는 이에 대해 지체없이 조치하겠습니다.
    <br/>
    이용자는 언제든지 홈페이지 ‘내정보 &gt; 회원정보’에서 개인정보를 직접 조회·수정·삭제하거나 ‘문의하기’를 통해 열람을 요청할 수 있습니다.
    <br/>
    이용자는 언제든지 ‘회원탈퇴’를 통해 개인정보의 수집 및 이용 동의 철회가 가능합니다.
    <br/>
    이용자는 언제든지 홈페이지 ‘내정보 &gt; 회원정보 &gt; 문의하기’를 통해 자동화된 결정의 거부 및 설명 요구가 가능합니다.
    <br/>
    <br/>
    <br/>
    ③ 권리 행사는 이용자의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수도 있습니다. 이 경우 “개인정보 처리 방법에 관한 고시” 별지 제11호 서식에 른 위임장을 제출하셔야 합니다.
    <br/>
    <br/>
    ④ 이용자가 개인정보 열람 및 처리 정지를 요구할 권리는 「개인정보 보호법」 제35조 제4항 및 제37조 제2항에 의하여 제한될 수 있습니다.
    <br/>
    <br/>
    ⑤ 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 해당 개인정보의 삭제를 요구할 수 없습니다.
    <br/>
    <br/>
    ⑥ 자동화된 결정이 이루어진다는 사실에 대해 이용자의 동의를 받았거나, 계약 등을 통해 미리 알린 경우, 법률에 명확히 규정이 있는 경우에는 자동화된 결정에 대한 거부는 인정되지 않으며 설명 및 검토 요구만 가능합니다.
    <br/>
    또한 자동화된 결정에 대한 거부·설명 요구는 다른 사람의 생명·신체·재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 등 정당한 사유가 있는 경우에는 그 요구가 거절될 수 있습니다.
    <br/>
    <br/>
    ⑦ 회사는 권리 행사를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.
    <br/>
    <br/>
    ⑧ 이용자는 아래의 부서에 권리 행사를 요청할 수 있습니다.

    <table class="table_1">
        <tr>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                부서명
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                담당자
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                연락처
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                이메일
            </th>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                정보보안팀
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                한재환
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                070-7433-0825
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                ddor3@davich.com
            </td>
        </tr>
    </table>
    <br/>
    <b style="font-size:20px">개인정보 보호책임자 및 담당부서</b>
    <br/>
    ① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자와 담당부서를 지정하고 있습니다.


    <table class="table_1">
        <tr>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                구분
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                조직
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                성명
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                직책
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                연락처
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                이메일
            </th>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                개인정보 보호책임자(CPO)
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                다비치안경체인
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                김봉건
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                CPO
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                070-7433-0825
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                developer@davich.com
            </td>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                개인정보보호 담당부서
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                정보보안팀
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                한재환
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                CISO
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                070-7433-0825
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                ddor3@davich.com
            </td>
        </tr>
    </table>
    <br/>
    ② 이용자는 회사의 서비스를 이용하시면서 발생한 모든 개인정보보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의할 수 있습니다. 회사는 이용자의 문의에 대해 지체없이 답변 및 처리해 드릴 것입니다.
    <br/>
    이용자의 권익침해에 대한 구제 방법
    <br/>
    <br/>
    ① 이용자는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등 아래 기관에 분쟁해결이나 상담 등을 신청할 수 있습니다.
    <br/>
    1. 개인정보 분쟁조정위원회 : (국번없이) 1833-6972 (www.kopico.go.kr)
    <br/>
    2. 개인정보침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr)
    <br/>
    3. 대검찰청 : (국번없이) 1301 (www.spo.go.kr)
    <br/>
    4. 경찰청 : (국번없이) 182 (ecrm.cyber.go.kr)
    <br/>
    <br/>
    ② 회사는 이용자의 개인정보자기결정권을 보장하고, 개인정보침해로 인한 상담 및 피해 구제를 위해 노력하고 있으며, 신고나 상담이 필요한 경우 아래의 담당부서로 연락해 주시기 바랍니다.

    <table class="table_1">
        <tr>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                부서명
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                담당자
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                연락처
            </th>
            <th style="border: 1px solid #ccc; padding: 8px; background-color: #f0f6ff;">
                이메일
            </th>
        </tr>
        <tr>
            <td style="border: 1px solid #ccc; padding: 8px;">
                정보보안팀
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                한재환
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                070-7433-0825
            </td>
            <td style="border: 1px solid #ccc; padding: 8px;">
                ddor3@davich.com
            </td>
        </tr>
    </table>
    <br/>
    <div>
        <a href="/별지 제3호서식 위임장_pdf.pdf" target="_blank">
            제3호서식 위임장 보기 (PDF)
        </a>
    </div>
    <br/>
    <b style="font-size:20px">개인정보 처리방침의 변경에 관한 사항</b>
    <br/>
    ① 이 개인정보 처리방침은 2025년 4월 30일부터 적용됩니다.
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    </p>
                  
                </div>
                <div class="agree-chk">
                  <input id="agree-chk" type="checkbox" v-model="isAgree" />
                  <label for="agree-chk"
                    >수집하는 개인정보 항목, 수집/이용목적, 개인정보 보유기간에
                    동의합니다.​<span>&#42;</span></label
                  >
                  <div class="chk-icon-wrap">
                    <img
                      class="chk-icon"
                      src="https://img.davich.com/image/sub/icon-form-checkbox.jpg"
                      alt="icon checkbox"
                    />
                  </div>
                </div>
                <div class="notice-form">
                  <p>
                    ※ 지원서는 공고 게시판에서 양식 다운로드 후 작성해서
                    첨부해주시기 바랍니다.<br /><br />
                  </p>
                  <p>
                    ※ 접수 후 24시간 이내에 접수 확인문자가 오지 않을 경우
                    070-7428-6637로 연락 주시기 바랍니다.
                  </p>
                </div>
              </div>
            </div>
            <!-- 개인정보 수집동의 부분 -->
            <button
              class="el-btn-m question-btn question-btn-left"
              @click="postFormData"
            >
              지원하기
            </button>
            <!-- 지원하기 버튼 -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SubTitle from "../../../components/mobile/MSubTitle1.vue";
import TabMenu from "../../../components/mobile/MTabMenu.vue";

import axios from "@/api/axios-auth";
import { mapGetters, mapState } from "vuex";

export default {
  beforeCreate() {
    this.$store.dispatch("education/FETCH_RECRUIT");
  },

  components: {
    SubTitle,
    TabMenu,
  },
  data() {
    return {
      title: "사관∙공채∙<br/>코디네이터 모집",
      content: "안경업계 최초로 자체 훈련기관으로 ",
      content2: "서울지방노동청의 승인을 받은 ",
      content3: "전문 교육기관에서 여러분의 꿈을 이루세요.",
      // tabTitle: ["사관∙공채∙코디네이터 공고", "사관∙공채∙코디네이터 지원"],
      tabTitle: ["사관∙공채∙코디네이터 공고"],

      currentPage: 1,
      perPage: 10,
      officer_disabled: false,
      coordinator_disabled: false,

      //formData
      type: "1",
      name: "",
      email: "",
      domain: "",
      mobile_no: "",
      file: "",

      tempEmail: "",
      inputDomain: "",

      authnumber_id: 0,
      authNumber: null,

      isCertified: false,
      isAgree: false,

      timer: null,
      timeCounter: 180,
      timeStr: "03:00",
    };
  },

  computed: {
    ...mapGetters("education", ["getRecruit"]),
    ...mapState({
      contents: (state) => state.others.privacy[0].contents,
    }),

    listToShow() {
      const self = this;
      let result;

      result = self.getRecruit.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
      return result;
    },
  },

  watch: {
    name(value) {
      const self = this;

      //공백인것,특수문자인것 제거
      const result = value
        .replace(/\s/g, "")
        .replace(/[/?.,;:|)*~`!^\-_+<>@#$%&\\=('"]/g, "");
      self.$nextTick(() => (self.name = result));
    },

    tempEmail(value) {
      const self = this;

      const result = value
        .replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/, "")
        .replace(/[@]/g, "");
      self.$nextTick(() => (self.tempEmail = result));
    },

    mobile_no(value) {
      const self = this;
      const btn = document.getElementById("get-authnum-btn");
      if (self.mobile_no.length == 11) {
        btn.classList.add("active");
      } else {
        btn.classList.remove("active");
      }

      //숫자아닌것 제거
      const result = value.replace(/\D/g, "");
      self.$nextTick(() => (self.mobile_no = result));
    },

    authNumber(value) {
      const self = this;
      const btn = document.getElementById("certifi-btn");
      if (self.authNumber.length == 6) {
        btn.classList.add("active");
      } else {
        btn.classList.remove("active");
      }

      //숫자아닌것 제거
      const result = value.replace(/\D/g, "");
      self.$nextTick(() => (self.authNumber = result));
    },

    domain() {
      const self = this;
      const domainInput = document.getElementById("input-domain");
      const domainSelect = document.getElementById("select-domain");
      if (self.domain == "0") {
        domainInput.removeAttribute("disabled");
        domainInput.style.display = "block";
        domainSelect.style.display = "none";
        domainInput.focus();
      } else {
        domainInput.setAttribute("disabled", true);
        self.inputDomain = self.domain;
      }
    },
  },

  created() {
    this.fetchApplyDateStatus();
  },

  mounted() {
    //게시물 10개 안될 시 더보기버튼 숨김
    const btn = document.getElementById("btnMoreData");
    if (this.perPage >= this.getRecruit.length) {
      btn.style.display = "none";
    }

    const self = this;
    let typeOfFile = typeof self.file;
    let delBtn = document.querySelector("#delete-file");

    //파일 첨부 시 경로 알려주기
    const inputEl = document.querySelector("#avatar");
    inputEl.addEventListener("change", function () {
      let fileList = inputEl.files;
      let file = fileList[0];

      //파일용량체크
      let maxSize = 50 * 1024 * 1024;
      if (file.size > maxSize) {
        alert("첨부파일 사이즈는 50MB 이내로 등록 가능합니다.");
        inputEl.value = "";
        return false;
      }

      self.file = file;
      typeOfFile = typeof self.file;
      if (typeOfFile == "object") {
        delBtn.style.display = "block";
        //display block
      }
    });

    //파일 삭제 기능
    delBtn.addEventListener("click", function () {
      let fileList = inputEl.files;
      if (fileList.length > 0) {
        self.file = "";
        inputEl.value = "";
        // display none
        delBtn.style.display = "none";
      }
    });

    // recruit detail 지원하러가기 링크 이동
    if (this.$route.query.index == "1") {
      const tabBtn = document.querySelectorAll(".tab-btn-m");
      const tabCont = document.querySelectorAll(".tab-item");

      tabBtn[0].classList.remove("active");
      tabBtn[1].classList.add("active");

      tabCont[0].classList.remove("display");
      tabCont[1].classList.add("display");
    }

    // 지원하기 클릭 후 위치 이동
    if (this.$route.query.index == "2") {
      const tabBtn = document.querySelectorAll(".tab-btn-m");
      const tabCont = document.querySelectorAll(".tab-item");
      tabBtn[0].classList.remove("active");
      tabBtn[1].classList.add("active");
      tabCont[0].classList.remove("display");
      tabCont[1].classList.add("display");
    }
  },

  methods: {
    async fetchApplyDateStatus() {
      try {
        const res = await axios.get("/education/officeropenrecruitment/apply/dateconfig/status");
        this.officer_disabled = !!res.data.officer_disabled;
        this.coordinator_disabled = !!res.data.coordinator_disabled;
      } catch (err) {
        console.error("fetchApplyDateStatus error => ", err);
        this.officer_disabled = false;
        this.coordinator_disabled = false;
      }
    },
    isClosing(due_date) {
      var currentDate = new Date();
      var dueDate = new Date(due_date);
      dueDate.setDate(dueDate.getDate() + 1);

      if (dueDate > currentDate) {
        // 마감일 지나지 않음.
        return false;
      } else {
        // 마감 지남
        return true;
      }
    },

    //타이머
    timeStart() {
      this.TimeCounter = 180;
      let interval = setInterval(() => {
        this.timeCounter--;
        this.timeStr = this.prettyTime();
        if (this.timeCounter <= 0) {
          this.timerStop(interval);
        }
      }, 1000);
      return interval;
    },
    timerStop(timer) {
      clearInterval(timer);
      this.timeCounter = 0;
    },
    prettyTime() {
      let time = this.timeCounter / 60;
      let minutes = parseInt(time);
      let secondes = Math.round((time - minutes) * 60);
      return (
        minutes.toString().padStart(2, "0") +
        ":" +
        secondes.toString().padStart(2, "0")
      );
    },
    setTimer() {
      if (this.timer != null) {
        this.timerStop(this.timer);
        this.timer = null;
      }
      this.timer = this.timeStart();
    },

    //휴대폰인증
    certifyMobile() {
      if (this.mobile_no == "") {
        alert("휴대폰 번호를 입력하세요");
        return 0;
      }
      const getAuthnumBtn = document.getElementById("get-authnum-btn");
      const certifyInput = document.getElementById("certifi-input");
      const certifyBtn = document.getElementById("certifi-btn");
      const countTimer = document.getElementById("timer");

      getAuthnumBtn.classList.add("active");
      certifyInput.classList.remove("hidden");
      certifyBtn.classList.remove("hidden");
      countTimer.classList.remove("hidden");
      this.setTimer();

      if (getAuthnumBtn.innerText != "재발급") {
        getAuthnumBtn.innerText = "재발급";
      } else {
        alert("인증번호가 재발송되었습니다.");
        //타이머 초기화
        this.timerStop(this.timer);
        this.timeCounter = 180;
        this.timeStr = "03:00";
        this.timer = null;
        this.timeStart();
      }

      axios
        .post("/message/authnumber", {
          board_name: "customer_voice",
          mobile_no: this.mobile_no,
        })
        .then((res) => {
          this.authnumber_id = res.data.id;
        })
        .catch((err) => console.log(err));
    },

    confirmMobile() {
      axios
        .post("/message/authnumber/check", {
          mobile_no: this.mobile_no,
          authnumber_id: this.authnumber_id,
          input_data: this.authNumber,
        })
        .then((res) => {
          if (res.status == 200) {
            alert("인증이 완료되었습니다.");
            this.isCertified = true;
            this.timerStop(this.timer);

            document.getElementById("get-authnum-btn").classList.add("hidden");
            document.getElementById("certifi-input").classList.add("hidden");
            document.getElementById("certifi-btn").classList.add("hidden");
            document.getElementById("timer").classList.add("hidden");

            document
              .getElementById("phonenumber")
              .setAttribute("disabled", true);
            document
              .getElementById("get-authnum-btn")
              .setAttribute("disabled", true);

            const confirm = document.getElementById("auth-confirm");
            confirm.classList.remove("hidden");
          }
        })
        .catch((err) => {
          switch (err.response.data.error_code) {
            case 1:
              alert("유효시간이 초과되었습니다.");
              break;
            case 2:
              alert("입력하신 번호가 일치하지 않습니다.");
              break;
          }
        });
    },

    getMoreData() {
      const btn = document.getElementById("btnMoreData");
      this.perPage += 5;

      //마지막 데이터에서 더보기버튼 숨김
      if (this.perPage >= this.getRecruit.length) {
        btn.style.display = "none";
      }
    },

    postFormData() {
      const self = this;

      //예외처리
      if (
        self.name.length == 0 ||
        self.email.length == 0 ||
        self.domain.length == 0 ||
        self.mobile_no.length == 0
      ) {
        alert("필수항목을 기입해 주세요");
        return 1;
      }

      if (self.isAgree == false) {
        alert("개인정보 수집동의에 체크해주세요.");
        return 1;
      }
      if (self.isCertified == false) {
        alert("휴대폰 인증을 완료해주세요.");
        return 1;
      }
      if (self.isAgree == true && self.isCertified == true) {
        const frm = new FormData();
        frm.append("type", self.type);
        frm.append("name", self.name);
        frm.append("email", self.email);
        frm.append("mobile_no", self.mobile_no);
        frm.append("file", self.file);

        axios
          .post(`/education/officeropenrecruitment/apply`, frm, {
            headers: {
              "Content-Type": `multipart/form-data`,
            },
          })
          .then(() => {
            alert("지원이 완료되었습니다.");
            this.$router.replace({
              path: "/education/m_recruit",
              query: { index: 2 },
            });

            //입력폼 초기화
            const inputEl = document.querySelector("#avatar");
            inputEl.value = "";
            self.name = "";
            self.email = "";
            self.tempEmail = "";
            self.domain = 0;
            self.inputDomain = "";
            self.mobile_no = "";
            self.file = "";

            self.authnumber_id = 0;
            self.authNumber = null;

            self.isCertified = false;
            self.isAgree = false;

            self.timer = null;
            self.timeCounter = 180;
            self.timeStr = "03:00";
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    //직접입력 이메일 합치기
    sumDomain() {
      const self = this;
      if (self.domain == "0") {
        let fullEmail = self.tempEmail + "@" + self.inputDomain;
        self.email = fullEmail;
      } else {
        self.email = self.tempEmail + "@" + self.domain;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/helpers/variables";
@import "~@/assets/scss/helpers/mixins";
@import "~@/assets/scss/base/typhography";

.waiting {
  font-size: 40px;
  color: $color-blue;
  font-weight: bold;
  text-align: center;
  line-height: 50px;
}

.sub-title {
  background-image: url("https://img.davich.com/mobile/image/sub/subtitle/sub-edu-bg-02.png");
  background-size: cover;
  .sub-title-txt {
    h2 {
      width: 238px;
      margin: 0 auto 10px auto;
    }
  }
}

.tab-btn-wrap {
  .tab-btn-m {
    letter-spacing: -0.45px;
  }
}
//사관공채공고
.recruit {
  margin-bottom: 100px;
  .recruit-board {
    margin-top: 80px;
    border-top: 2px solid #ccc;
    .board-item {
      border-bottom: 1px solid #dedede;
      &.board-recruiting {
        a {
          color: $color-blue;
        }
        span {
          color: $color-blue;
        }
      }
      a {
        color: $color-black;
        margin: 20px 12px 15px 12px;

        font-size: 15px;
        font-weight: 500;
        line-height: 20px;
        display: inline-block;
      }
      span {
        font-size: 13px;
        color: #ccc;
        letter-spacing: -0.54px;
        display: inline-block;
        margin-left: 10px;
        margin-bottom: 20px;
      }
      .isClose {
        color: $color-black !important;
      }
    }
  }
  .el-btn-m {
    margin-top: 100px;
  }
}
//사관공채지원 오민사상
.apply {
  padding: 0px 0 100px 0;
  .thought {
    width: 100vw;
    height: 1500px;
    background-color: #f0f8ff;
    position: relative;
    .img-wrap img {
      width: 325px;
      display: block;
      margin: 0px auto 80px auto;
      padding-top: 80px;
    }
    .thought-item {
      left: 50%;
      text-align: center;
      margin-top: 50px;
      h4 {
        font-size: 18px;
        font-weight: bold;
        letter-spacing: -0.9px;
        margin-bottom: 10px;
        color: $color-blue;
        span {
          font-family: $ch-font;
        }
      }
      p {
        font-size: 14px;
        line-height: 28px;
        letter-spacing: -0.54px;
      }
    }
    .thoughttext {
      left: 50%;
      text-align: center;
      h3 {
        font-weight: bold;
        font-size: 18px;
        line-height: 30px;
        letter-spacing: -0.9px;
        text-align: center;
        margin-top: 70px;
      }
      > p {
        margin-top: 22px;
        text-align: center;
        font-size: 14px;
        line-height: 28px;
        letter-spacing: -0.54px;
      }
    }
  }
}
// 사관·공채 지원 지원내용
.ly-form-m {
  &.apply-form {
    margin-top: 70px;
  }
  h2 {
    text-align: center;
    font-size: 25px;
    margin: 20px 0;
    padding: 60px 0 40px 0;
  }
  .ly-form-cont {
    h3 {
      font-size: 22px;
    }
    .form-cont {
      p.apply-classify-form {
        em {
          display: block;
          padding-top: 30px;
          width: 110px;
          font-size: 16px;
          font-weight: 500;
          line-height: 30px;
          letter-spacing: -0.66px;
          flex-shrink: 0;
          span {
            display: inline-block;
            margin-left: 4px;
            color: $color-skyblue;
          }
        }
        .radio-form-wrap {
          display: inline-block;
          padding-right: 50px;
          box-sizing: border-box;
          padding: 10px 0 10px 0;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          .radio-form {
            display: inline-flex;
            align-items: center;
            padding-top: 20px;
            margin-right: 30px;
            &:last-child {
              margin-right: 0;
            }
            label {
              padding: 0 !important;
              width: auto;
            }
            input[type="radio"] {
              width: 26px !important;
              height: 26px;
              margin-right: 10px;
              &:checked {
                color: $color-blue;
                & + label {
                  color: $color-blue;
                }
              }
            }
          }
        }
      }
      //file form 파일첨부
      .file-form {
        display: flex;
        margin-top: 10px;
        > span {
          display: inline-block;
          width: calc(100% - 108px);
          input[id="upload-name"] {
            border-bottom: none;
            width: 100%;
            height: 60px;
            background-color: #f9f9f9;
            color: #ccc;
            padding-left: 10px;
            font-size: 13px;
          }
          .file-btn-wrap {
            margin-top: 10px;
            display: flex;
            label[for="avatar"] {
              display: inline-block;
              width: 50%;
              height: 60px;
              line-height: 60px;
              text-align: center;
              font-size: 16px;
              border: 1px solid $color-black;
              cursor: pointer;
              padding: 0;
            }
            > span {
              display: inline-block;
              width: 50%;
              height: 60px;
              border: 1px solid #dedede;
              button {
                display: inline-block;
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                left: -6px;
              }
            }
          }
          em {
            display: block;
            font-size: 13px;
            line-height: 20px;
            margin-top: 15px;
            letter-spacing: -0.39px;
          }
          input[type="file"] {
            position: absolute;
            width: 0;
            height: 0;
            padding: 0;
            overflow: hidden;
            border: 0;
          }
        }
      }
    }
  }
}
//filebox
.filebox .upload-name {
  display: inline-block;
  height: 60px;
  padding: 0 10px;
  color: #ccc;
  background-color: #f9f9f9;
  font-size: 16px;
}
.filebox label {
  height: 60px;
  display: inline-block;
  margin-right: 10px;
  cursor: pointer;
  font-family: $ko-font;
  border: 1px solid #777;
}
//개인정보 수집동의 밑에 텍스트 박스
.notice-form {
  display: inline-block;
  width: 85vw;
  background-color: #f0f8ff;
  padding: 20px 20px;
  margin: 40px auto 0px auto;
  font-size: 14px;
  line-height: 30px;
}
#pagination {
  display: none;
}
</style>
